
import ActionResultEvents from "../constants/events/ActionResultEvents";
import StoreUpdateEvents from "../constants/events/StoreUpdateEvents";

import BaseStore from "./BaseStore";
import UIInteractionEvents from "../constants/events/UIInteractionEvents";

export class ErrorStates {
    static ERROR = Symbol("ERROR");
    static CLEAR = Symbol("CLEAR");
}

class ErrorState {

    constructor(errorState, errorMessage) {
        this.errorState = errorState;
        this.errorMessage = errorMessage;
    }

    equals(other) {
        return this.errorState === other.errorState &&
            this.errorMessage === other.errorMessage;
    }
}

class ImmutableErrorStateBuilder {

    constructor() {
        this.errorState = ErrorStates.CLEAR;
        this.errorMessage = "";
    }

    setError(errorMessage) {
        this.errorState = ErrorStates.ERROR;
        this.errorMessage = errorMessage;
        return this;
    }

    build() {
        return Object.freeze(new ErrorState(this.errorState, this.errorMessage));
    }
}

class ErrorStore extends BaseStore {

    constructor() {
        super(StoreUpdateEvents.ERROR_STORE_UPDATED, ImmutableErrorStateBuilder);
        this.subscribeToEvent(ActionResultEvents.SERVER_ERROR, this.setError);
        this.subscribeToEvent(UIInteractionEvents.CLEAR_ERROR_BUTTON_CLICKED, this.resetStore);
    }

    setError = (topic, data) => {
        return new ImmutableErrorStateBuilder().setError(data.error).build();
    };

}

export default new ErrorStore();
